module.exports = __webpack_public_path__ + "img/2025big11.3d801f5e.jpg";